module.exports = __webpack_public_path__ + "img/ic-check-white.f0a11fb6.svg";